<div class="feature text-14">
  <div class="mb-4" *ngIf="label">
    {{ label }}
  </div>

  <app-list listType="flat">
    <app-list-item *ngFor="let feature of features">
      <div class="mv-1 flex flex-row">
        <app-icon class="mr-2" icon="check"></app-icon>
        <div>{{ feature }}</div>
      </div>
    </app-list-item>
  </app-list>
</div>
